import PerfectScrollbar from 'perfect-scrollbar';

//------------------------------------------Popup Class-----------------------------------------
class Popup {

    constructor(popup, toggleEl=null, isClickBgClose=true) {
        this.popup = popup;

        //bind this to the class function
        this.toggleElOnClick = this.toggleElOnClick.bind(this);
        this.openPopup = this.openPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);

        //bind click event handler to toggle element
        toggleEl && toggleEl.each((i, el) => $(el).on('click', this.toggleElOnClick));
        //bind closePopup to close-btn when click
        this.popup.find('.close-btn').on('click', this.closePopup);
        this.popup.find('.btn-close').on('click', this.closePopup);
        //when user click on the popup-background, close the popup
        if(isClickBgClose) {
            this.popup.find('.popup-background').on('click', (e) => {
                //prevent popup close when click on the popup-body
                //ensure user is click on the bg
                if($(e.target).closest('.popup-body').length === 0) {
                    this.closePopup();
                }
            });
        }
    }

    //---------------------------------------------event handler
    toggleElOnClick(e) {
        e.preventDefault();
        this.popup.hasClass('active') ? this.closePopup() : this.openPopup();
    }

    openPopup() {
        //$('.popup').removeClass('active');
        this.popup.addClass('active');
    }

    closePopup() {
        this.popup.removeClass('active');
    }

}

//-----------------------------------------------Popups-----------------------------------------------------------

//-------------------------------------Excel Popup
function initUploadInput(fileInput) {
    //a layer is added above the input as the placeholder
    const uploadInputLabel = fileInput.parent().find('label');
    const hidePlaceholder = () => fileInput.val() && uploadInputLabel.css('display', 'none');

    //when the user selected a file, hide the placeholder layer
    fileInput.on('change', hidePlaceholder);

    //checkinf any pre-selected file. if yes, hide placeholder layer
    hidePlaceholder();
}

function initExcelPopup() {
    //init excel upload input
    initUploadInput($('#excel-popup input[name=excel]'));
    // init excel popup
    window.popups.excelPopup = new Popup($('#excel-popup'), $('.toggle-excel-popup'));
    if(uploadExcelFailure) {
        window.popups.excelPopup.openPopup();
    }
}

function initBankSlipPopup() {
    initUploadInput($('#bank-slip-popup input[name=bank_slip]'));
    window.popups.bankSlipPopup = new Popup($('#bank-slip-popup'), $('#toggle-bank-slip-popup'));
    if(uploadBankSlipFailure) {
        window.popups.bankSlipPopup.openPopup();
    }
}

//-----------------------------------------Excel Error Popup
/*function initExcelErrorPopup() {
    //init excel upload input
    initUploadInput($('#excel-error-popup input[name=excel_file]'));

    //init excel error popup
    const excelErrorPopup = new Popup($('#excel-error-popup'));
    $('#excel-popup form button[type=submit]').on('click', (e) => {
        e.preventDefault();
        excelErrorPopup.openPopup();
    })
}*/

export default Popup

export { initExcelPopup, initBankSlipPopup, Popup };